import * as chefEmailsCoordinators from './chefEmails'
import * as clientSettingsCoordinators from './clientSettings'
import * as clientGlobalSettingsCoordinators from './clientGlobalSettings'
import * as dateMenusCoordinators from './dateMenus'
import * as groupOrdersCoordinators from './groupOrders'
import * as menuCoordinators from './menus'
import * as dateMenuTemplatesCoordinators from './dateMenuTemplates'
import * as chefPayoutOverridesCoordinators from './chefPayoutOverrides'
import * as cancellationsCoordinators from './cancellations'

export default Object.freeze({
  ...chefEmailsCoordinators,
  ...clientSettingsCoordinators,
  ...clientGlobalSettingsCoordinators,
  ...dateMenusCoordinators,
  ...groupOrdersCoordinators,
  ...menuCoordinators,
  ...dateMenuTemplatesCoordinators,
  ...chefPayoutOverridesCoordinators,
  ...cancellationsCoordinators,
})
